<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        title="物料信息表"
        class="customer-edit"
        width="1000px"
        top="5vh"
        @close="onDialogClose">
      <el-button :loading="submitLoading" style="margin-bottom: 3%" type="primary" @click="handleSubmit">保存</el-button>
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          method="get"
          module="basic"
          url="baseMaterials"
          @select="selectTest"
          @select-all="selectAll">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="物料编号">
              <el-input v-model.trim="filter.no" clearable/>
            </vm-search>
            <vm-search label="物料名称">
              <el-input v-model.trim="filter.name" clearable/>
            </vm-search>
            <vm-search label="物料组">
              <el-input v-model.trim="filter.materialGroupNO" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" width="55"/>
        <el-table-column prop="no" label="物料编号"/>
        <el-table-column prop="name" label="物料描述"/>
        <el-table-column prop="materialGroupNO" label="物料组"/>
        <el-table-column prop="productGroupNO" label="产品组"/>
        <el-table-column prop="purchaseGroupNO" label="采购组"/>
      </vm-table>
    </el-dialog>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch";

  export default {
    components: {VmSearch, VmTable},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        materials: {
          id: "",
        },
        filter: {
          supplierInfoId: "",
          no: "",
          name: "",
          materialGroupNO: "",
        },
        idList: "",
      };
    },
    methods: {
      open(id) {
        this.filter.supplierInfoId = id;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      handleSubmit() {
        this.newPkids=[];
        for(let item of this.idList) {
          this.newPkids.push(item.id);
        }
        let prams = {
          supplierID:this.filter.supplierInfoId,
          ids: this.newPkids,
        };
        this.$http
          .post("basic", "baseMaterials/supplierInfo",prams)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$message.success("保存成功");
            this.$emit("save-success");
            this.idList = "";
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      onDialogClose() {
        this.submitLoading = false;
        this.contentLoading = false;
        this.materials.id = 0;
        this.idList = "";
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
